import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LinkedJobRow } from '@classes/linked-patients';

export interface LinkedJobsDialogData {
  jobs: LinkedJobRow[];
  notifyPreference?: string;
}

@Component({
  selector: 'app-linked-jobs-dialog',
  template: `
    <h2 mat-dialog-title>LINKED JOBS</h2>
    <mat-dialog-content>
      <div class="job-row" *ngFor="let job of data.jobs">
        <div class="job-name">{{ job.patientName }}</div>
        <div class="job-invoice">{{ job.invoiceNumber }}</div>
        <div class="job-ready" [class.ready]="job.ready">
          {{ job.ready ? 'Ready' : 'Not Ready' }}
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">CLOSE</button>
      <button mat-stroked-button type="button" (click)="dialogRef.close({ preference: 'WAIT_ALL' })">
        WAIT FOR ALL LINKED ORDERS
      </button>
      <button mat-raised-button color="primary" type="button" (click)="dialogRef.close({ preference: 'EACH' })">
        NOTIFY NOW
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .job-row {
        display: grid;
        grid-template-columns: 1fr auto 110px;
        gap: 8px;
        padding: 8px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      .job-ready {
        text-align: right;
        font-weight: 600;
        color: #9a3412;
      }
      .job-ready.ready {
        color: #166534;
      }
    `,
  ],
})
export class LinkedJobsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LinkedJobsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LinkedJobsDialogData
  ) {}
}
